import axios from "axios";
import { apiURL } from "./constants";

/**
 * TODO(permissions #151): No frontend helper yet for
 * GET /api/send_whatsapp_shipment_notification_test/.
 * Permission: PERMISSIONS.WHATSAPP_SEND_SHIPMENT_TEST.
 * When adding the helper + UI, gate the caller via
 * <PermissionGate /> or hasPermission().
 * See ENDPOINTS_USAGE.md Phase 7.
 */

//get invoice throw api 
export async function sendWhatsAppShipmentNotification(shipmentId) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    // get request using axios with error handling
    const response = await axios.get(`${apiURL}/api/send_whatsapp_shipment_notification/?shipment_id=${shipmentId}`,
      {
        headers:
          { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    )
      .catch((error) => {
        console.error('There was an error!', error);
        throw error;
      });
  
    return response;
  }

export async function sendWhatsAppInvoiceNotification(invoiceId) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
    const response = await axios.get(`${apiURL}/api/send_whatsapp_invoice_notification/?invoice_id=${invoiceId}`,
      {
        headers:
          { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    )
      .catch((error) => {
        console.error('There was an error!', error);
        throw error;
      });

    return response;
  }